"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFidmanSyncStatus = fetchFidmanSyncStatus;
exports.retryFidmanSync = retryFidmanSync;
/**
 * SYNC-P2 — PS proxy abstraction for the FIDman sync status/retry surface.
 * Mirrors ./aqmMatchService.ts (injectable-fetcher pattern, PS backend proxy,
 * no third-party token in the browser).
 *
 * Backend: PS-nodeJS src/contracts/fidmanSync/FidmanSyncRouters.ts
 *   GET  {PS_API}fidmanSync/contract/:id/status
 *   POST {PS_API}fidmanSync/contract/:id/retry
 */
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
async function fetchFidmanSyncStatus(contractId, fetcher = fetch) {
    const url = `${MainSetupReact_1.default.serverUrl}contract/${contractId}/fidmanSync/status`;
    const response = await fetcher(url, { method: "GET", credentials: "include" });
    if (!response.ok) {
        throw new Error(`Błąd odczytu statusu synchronizacji FIDman: ${response.status}`);
    }
    return response.json();
}
/** Manual "dopchnij synchronizację" — re-delivers the last FAILED/SKIPPED row. */
async function retryFidmanSync(contractId, fetcher = fetch) {
    const url = `${MainSetupReact_1.default.serverUrl}contract/${contractId}/fidmanSync/retry`;
    const response = await fetcher(url, { method: "POST", credentials: "include" });
    if (!response.ok) {
        // Backend errors come back as JSON { error }; read that, not the raw body
        // (a 404 { "error": "..." } must not render as a JSON blob in the Alert).
        const msg = await response
            .json()
            .then((body) => body?.error)
            .catch(() => undefined);
        throw new Error(msg || `Błąd ponowienia synchronizacji FIDman: ${response.status}`);
    }
    return response.json();
}
